import expImg1 from '../assets/png/abfish.png';
import expImg2 from '../assets/png/shoprite.png';
import expImg3 from '../assets/png/barrow.png';
import expImg4 from '../assets/png/coder.png';
import expImg5 from '../assets/png/cps.png';
import expImg6 from '../assets/png/njit.jpeg';
import expImg8 from '../assets/png/smbc.png';

export const experienceData = [
    {
        id: 1,
        company: 'Absolutely Fish',
        jobtitle: 'Stock Manager / Aquarist',
        startYear: 'July 2020',
        endYear: 'March 2022',
        image: expImg1,
        details: [
            'Assisted customers to find habitable fish for their specific aquariums',
            'Headed inventory and management of dry good placement to ensure adequate supplies for sale',
            'Ordering and receiving of dry good orders',
        ],
    },
    {
        id: 2,
        company: 'ShopRite',
        jobtitle: 'Front-end Manager',
        startYear: 'March 2022',
        endYear: 'January 2023',
        image: expImg2,
        details: [
            'Supervised cashiers in their daily tasks in order to ensure company profits and loss prevention',
            'Controlled sales of age restricted items (Alcohol, Cigarettes, etc.)',
            'Oversaw customer satisfaction in situational dilemma\'s or store discrepancies',
        ],
    },
    {
        id: 3,
        company: 'Barrow House',
        jobtitle: 'Bartender / Bar Back',
        startYear: 'March 2023',
        endYear: 'January 2024',
        image: expImg3,
        details: [
            'Assisted the bartenders in making drinks',
            'Inventory management of in stock liquors, fresh juices and fruits',
        ],
    },
    {
        id: 6,
        company: 'NJIT',
        jobtitle: 'IT201 Teachers Assistant',
        startYear: 'February 2024',
        endYear: 'January 2025',
        image: expImg6,
        details: [
            'Assisted students in completing course content',
            'Provided remedial for students struggling to grasp topics taught in class',
        ],
    },
    {
        id: 7,
        company: 'NJIT',
        jobtitle: 'IT101, IT230, IT340, IT342 Lab Assistant',
        startYear: 'January 2025',
        endYear: 'May 2025',
        image: expImg6,
        details: [
            'Researched relevant Cloud, Linux, and Security practices in order to construct nearly 100 labs for student learning in their coursework',
            'Constructed 8 weekly cohesive labs based on core principles of the course content and creating small scale labs in AWS, GCP, Azure, and various other online security sandboxes such as Cybrary',
        ],
    },
    {
        id: 4,
        company: 'theCoderSchool Montclair',
        jobtitle: 'Assistant Manager + Code Coach',
        startYear: 'August 2023',
        endYear: 'February 2026',
        image: expImg4,
        details: [
            'Running daily administrative tasks such as scheduling and billings',
            'Creating lessons that are fun and engaging to younger audiences to keep them interested in learning',
            'Teaching various coding languages and platforms such as Scratch, Python, JavaScript, and more',
        ],
    },
    {
        id: 5,
        company: 'Clifton Public Schools',
        jobtitle: 'Substitute Teacher',
        startYear: 'December 2023',
        endYear: 'February 2026',
        image: expImg5,
        details: [
            'Supervise a classroom environment and ensure student behavior',
            'Administer assignments based on teacher instructions',
        ],
    },
    {
        id: 8,
        company: 'Sumitomo Mitsui Banking Corporation (SMBC)',
        jobtitle: 'Application Security Risk Assessment Coordinator',
        startYear: 'February 2026',
        endYear: 'Present',
        image: expImg8,
        details: [
            'Communicated with application owners to complete low- & medium-risk application security risk assessments for over 170 enterprise applications to ensure IT compliance.',
            'Documented 40+ risk acceptances to formally identify and propose remediation for control gaps found in applications non-compliant to SMBC security policy & procedures.',
            'Conducted cloud and external service assessments with stakeholders to ensure security and confidentiality of SMBC data within vendor premises.',
            'Mentored and trained 3 team members on SMBC’s risk management strategies and risk tolerances to further output of backlogged security risk assessments',
        ],
    },
];
